import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import LimitingDisplacement from './LimitingDisplacement';
import Spinner from '@components/LoadingStyles/Spinner';
import {
  connectionTypes, designOptions,
  seismicParams
} from '../misc/seismic.class';
import loadsTabService from '@services/requests/loads-tab.service';
import './styles.scss';
import { BRAND } from '@config';
import { brandList, standardList, countryList } from '../../../../../app.values';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';
import { APP_TEXTS } from '../../../../../texts/texts';
import { Tooltip } from '@components/Tippy';
import { APP_TOOLTIPS } from '../../../../../texts/tooltips';
import Popup from 'reactjs-popup';
import Input from '@components/Input';
import seismicTableFR from '../../../../../assets/images/Seismic_Table_C1_C2_FR.png';
import seismicTableUK from '../../../../../assets/images/Seismic_Table_C1_C2_UK.png';
import greenCross from '../../../../../assets/images/green_cross.png';

class SeismicLoads extends PureComponent {

  static propTypes = {
    combination: PropTypes.object.isRequired,
    designStd: PropTypes.string.isRequired
  };

  classes = [];
  levels = [];

  constructor(props) {
    super(props);
    this.fetchOptions();

    this.state = {
      buildingImportanceClass: null,
      connections: null,
      seismicPerformance: null,
      designOption: null,
      isPending: true
    };
  }

  fetchOptions() {
    Promise.all([
      loadsTabService.getBuildingImportance(),
      loadsTabService.getSeismicityLevels()
    ])
      .then(this.handleResponse)
      .then(
        this.unsetPending,
        this.unsetPending
      );
  }

  handleResponse = ([classes, levels]) => {
    this.classes = classes;
    this.levels = levels;
  };

  unsetPending = () => this.setState({ isPending: false });

  render() {
    const { combination: { extraField = {} } } = this.props;

    if (!extraField[seismicParams.BUILDING_IMPORTANCE_CLASS]) {
      extraField[seismicParams.BUILDING_IMPORTANCE_CLASS] = this.state.buildingImportanceClass;
    }

    if (!extraField[seismicParams.CONNECTIONS]) {
      extraField[seismicParams.CONNECTIONS] = this.state.connections;
    }

    if (!extraField[seismicParams.SEISMIC_PERFORMANCE]) {
      extraField[seismicParams.SEISMIC_PERFORMANCE] = this.state.seismicPerformance;
    }

    if (!extraField[seismicParams.DESIGN_OPTION]) {
      extraField[seismicParams.DESIGN_OPTION] = this.state.designOption;
    }

    return (
      <div className="calculation">
        {this.state.isPending && <Spinner />}

        {!(this.IsICC4RedHeadOrRamset) && (
          <section className="list-type">
              <h4>
                {Number(this.props.designStd) === standardList['AS5216'] ? 
                  APP_TEXTS.SEISMICITY_LEVEL_AS5216.Content : APP_TEXTS.SEISMIC_LOADS.Content}
              </h4>

              <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMICITY_LEVEL.Content}>
                <select
                  className="form-control select__wide"
                  name={seismicParams.SEISMICITY_LEVEL}
                  value={extraField[seismicParams.SEISMICITY_LEVEL]}
                  onChange={e => this.updateValue(e.target.value, seismicParams.SEISMICITY_LEVEL)}
                  disabled={extraField["frenchArea"]}
                  >
                  {this.levels && this.levels.map(n => (
                    <option value={n['InternalName']} key={n['InternalName']}>{n['RunName']}</option>
                  ))}
                </select>
              </Tooltip>
          </section>
        )}

        {(Number(this.props.country) === countryList.France || BRAND === brandList.Spit) && (
          <section className="list-type row">
            {Number(this.props.country) === countryList.France && (
              <React.Fragment>
                <div className="mx-3">
                  <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_FRANCE_MAP.Content}>
                    <Popup 
                      modal={true}
                      closeOnDocumentClick={false}
                      className="map_popup default_popup"
                      trigger={( 
                          <button className="btn p-0">
                            <span className="icon_seismic-btn align-middle"/>
                          </button>
                      )}
                      onOpen={() => {
                        if (extraField["frenchArea"]) {
                          if (extraField["frenchArea"].PostalCode)
                            this.queryZipCode(extraField["frenchArea"].PostalCode);
                          this.setState({ 
                            selectedTown: extraField["frenchArea"], 
                            zipCode: extraField["frenchArea"].PostalCode || '',
                            isValidZipCode: extraField["frenchArea"].PostalCode ? true : false });
                        } else {
                          this.setState({ 
                            selectedTown: null, 
                            zipCode: '',
                            isValidZipCode: false });
                        }
                      }}
                      >
                      {close =>(
                        <React.Fragment>
                          <h4 className="default_popup-header">{APP_TEXTS.LOADS_MAP.Content}</h4>
                          <div className="default_popup-text">
                            <div className="left-side">
                              <span className="france-seismic-map"/>
                            </div>
                            <section className="list-type ml-2 right-side">
                              <div>
                                <p>{APP_TEXTS.LOADS_SEISMIC_FRANCE_DESC.Content}</p>
                                <p>{APP_TEXTS.LOADS_SEISMIC_ZONE_1.Content}<br/>
                                {APP_TEXTS.LOADS_SEISMIC_ZONE_2.Content}<br/>
                                {APP_TEXTS.LOADS_SEISMIC_ZONE_3.Content}<br/>
                                {APP_TEXTS.LOADS_SEISMIC_ZONE_4.Content}<br/>
                                {APP_TEXTS.LOADS_SEISMIC_ZONE_5.Content}</p>
                              </div>
                              
                              <div>
                              <Input 
                                className="mb-2 mt-2"
                                id="zip-code"
                                prefix={(<b>{APP_TEXTS.LOADS_ZIP_CODE.Content}</b>)}
                                postfix={this.state.waitingResponse ? 
                                  (<div className="spinner-border text-dark ml-2"/>) : 
                                  (this.state.zipCode ? 
                                    (this.state.isValidZipCode ? 
                                      (<span className="icon_check ml-2"/>) : 
                                      (<span className="icon_uncheck ml-2"/>)) :
                                    (<span/>)
                                  )}
                                value={this.state.zipCode}
                                onUpdate = { value => { 
                                  if (value !== this.state.zipCode) {
                                    this.setState({ zipCode: value }); 
                                    if (value.toString().length === 5) {
                                      this.queryZipCode(value);
                                    } else {
                                      this.setState({ isValidZipCode: false });
                                    }
                                  }
                                }}
                              />
                              {this.state.isValidZipCode && (
                                <React.Fragment>
                                  <label htmlFor="town" className="mb-2">
                                    <span><b>{APP_TEXTS.LOADS_TOWN.Content}</b></span>
                                    <select
                                      id="town"
                                      className="form-control"
                                      value={this.state.selectedTown["Town"]}
                                      onChange = { e => { 
                                        let selectedTown = this.state.towns.find(town => town.Town === e.target.value);
                                        this.setState({ selectedTown });
                                      }}
                                    >
                                      {this.state.towns && this.state.towns.map(town => (
                                        <option value={town.Town} key={town.Town}>{town["Town"]}</option>
                                      ))}
                                    </select>
                                  </label>
                                  <label htmlFor="zone">
                                    <span><b>{APP_TEXTS.LOADS_ZONE.Content}</b></span>
                                    <span id="zone">{this.state.selectedTown["SeismicZone"]}</span>
                                  </label> 
                                  
                                </React.Fragment>
                              )}
                              </div>
                            </section>
                          </div>
                          <div className="default_popup-footer">
                            <button
                              onClick={() =>{
                                this.props.onUpdate({
                                  frenchArea: this.state.selectedTown
                                });
                                switch (Number(this.state.selectedTown["SeismicZone"])) {
                                  case 1: { this.updateValue("0", seismicParams.SEISMICITY_LEVEL); break; }
                                  case 2: { this.updateValue("1", seismicParams.SEISMICITY_LEVEL); break; }
                                  case 3: 
                                  case 4: 
                                  case 5: { this.updateValue("2", seismicParams.SEISMICITY_LEVEL); break; }
                                  default: break;
                                }
                                close();
                              }}
                              className="btn btn-sm default_popup-button"
                              disabled={!this.state.selectedTown || !this.state.isValidZipCode}
                            >
                              {APP_TEXTS.ANCHOR_SELECTION_OK.Content}
                            </button>
                            <button
                              onClick={() =>{
                                this.setState({ zipCode: "", selectedTown: "" });
                                close();
                              }}
                              className="btn btn-sm default_popup-button"
                            >
                              {APP_TEXTS.BUTTONS_CANCEL.Content}
                            </button>
                          </div>
                          </React.Fragment>
                        )}
                    </Popup>  
                  </Tooltip>
                  {extraField["frenchArea"] && (
                    <button
                      className="btn p-0 ml-2" 
                      onClick={() => { 
                        this.props.onUpdate({ frenchArea: null });
                        this.setState({ zipCode: "", selectedTown: "", isValidZipCode: false });
                      }}>
                      <img alt="Cross" src={greenCross} width={30}/>
                    </button>
                  )}
                </div>
                <div className="ml-2">
                  {extraField["frenchArea"] && (
                    <div className="zone-desc">
                      <label htmlFor="zipCode">{APP_TEXTS.LOADS_ZIP_CODE.Content}</label> 
                      <span id="zipCode">{extraField["frenchArea"].PostalCode}</span> <br/>
                      
                      <label htmlFor="town">{APP_TEXTS.LOADS_TOWN.Content}</label> 
                      <span id="town">{extraField["frenchArea"].Town}</span> <br/>
                      
                      <label htmlFor="zone">{APP_TEXTS.LOADS_ZONE.Content}</label> 
                      <span id="zone">{extraField["frenchArea"].SeismicZone}</span>
                    </div>
                  )}
                </div>
              </React.Fragment>
            )}
            {BRAND === brandList.Spit && (
              <div className="mx-3">
                <Popup
                  modal={true}
                  closeOnDocumentClick={true}
                  className="seismic_popup default_popup"
                  trigger={( 
                    <button className="seismic-table-btn btn p-1">
                      <span>C1/C2</span>
                    </button>
                  )}>
                  {close => (
                    <React.Fragment>
                      <div className="seismic_popup-text default_popup-text">
                        <img alt="Seismic-Table" src={Number(this.props.country) === countryList.France ? seismicTableFR : seismicTableUK}/>
                      </div>
                      <div className="default_popup-footer">
                        <button
                          onClick={() =>close()}
                          className="btn btn-sm default_popup-button"
                        >
                          {APP_TEXTS.CLOSE.Content}
                        </button>
                      </div>
                    </React.Fragment>
                  )}
                </Popup>
              </div>
            )}
          </section>
        )}

        {!(this.IsICC4RedHeadOrRamset) && (
          <section className="list-type">
            <h4>
              {Number(this.props.designStd) === standardList['AS5216'] ? 
                APP_TEXTS.BUILDING_IMPORTANCE_LEVEL.Content : APP_TEXTS.BUILDING_IMPORTANCE_CLASSES.Content}
            </h4>

            <div className="btn-group">
              {this.classes && this.classes.map(n => (
                <Tooltip content={this.getBuildingClassTooltip(n['InternalName'])} key={n['InternalName']}>
                  <button
                    className={`btn ${extraField[seismicParams.BUILDING_IMPORTANCE_CLASS] === n['InternalName'] && 'ToggleButton--active'}`}
                    key={n['InternalName']}
                    onClick={() => {
                      this.updateValue(n['InternalName'], seismicParams.BUILDING_IMPORTANCE_CLASS);
                      this.setState({
                        buildingImportanceClass: n['InternalName']
                      });
                    }}
                  >
                    {n['RunName']}
                  </button>
                </Tooltip>
              ))}
            </div>
          </section>
        )}

        {!(this.IsICC4RedHeadOrRamset) && (
          <section className="list-type type-of-connection">
            <h4>{APP_TEXTS.TYPE_OF_CONNECTIONS.Content}</h4>

            <div className="btn-group">
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_STRUCTURAL_ELEMENTS.Content}>
                <button
                  className={`btn ${extraField[seismicParams.CONNECTIONS] === connectionTypes.STRUCTURAL && 'ToggleButton--active'}`}
                  color="secondary"
                  onClick={() => {
                    this.updateValue(connectionTypes.STRUCTURAL, seismicParams.CONNECTIONS);
                    this.setState({
                      connections: connectionTypes.STRUCTURAL
                    });
                  }}
                >
                  {APP_TEXTS.SEISMIC_LOADS_STRUCTURAL.Content}
                </button>
              </Tooltip>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_NON_STRUCTURAL_ELEMENTS.Content}>
                <button
                  className={`btn ${extraField[seismicParams.CONNECTIONS] === connectionTypes.NON_STRUCTURAL && 'ToggleButton--active'}`}
                  color="secondary"
                  onClick={() => {
                    this.updateValue(connectionTypes.NON_STRUCTURAL, seismicParams.CONNECTIONS);
                    this.setState({
                      connections: connectionTypes.NON_STRUCTURAL
                    });
                  }}
                >
                  {APP_TEXTS.SEISMIC_LOADS_NON_STRUCTURAL.Content}
                </button>
              </Tooltip>
            </div>
          </section>
        )}

        {!(this.IsICC4RedHeadOrRamset) && (
          <section className="list-type type-of-connection">
            <h4>{APP_TEXTS.TYPE_OF_PERFORMANCE.Content}</h4>

            <div className="btn-group">
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_CATEGORY_C1.Content}>
                <button
                  className={`btn ${extraField[seismicParams.SEISMIC_PERFORMANCE] === 'c1' && 'ToggleButton--active'}`}
                  color="secondary"
                  onClick={() => {
                    this.updateValue('c1', seismicParams.SEISMIC_PERFORMANCE);
                    this.setState({
                      seismicPerformance: 'c1'
                    });
                  }}
                >
                  {APP_TEXTS.SEISMIC_LOADS_CATEGORY_C1.Content}
                </button>
              </Tooltip>
              <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_CATEGORY_C2.Content}>
                <button
                  className={`btn ${extraField[seismicParams.SEISMIC_PERFORMANCE] === 'c2' && 'ToggleButton--active'}`}
                  color="secondary"
                  onClick={() => {
                    this.updateValue('c2', seismicParams.SEISMIC_PERFORMANCE);
                    this.setState({
                      seismicPerformance: 'c2'
                    });
                  }}
                >
                  {APP_TEXTS.SEISMIC_LOADS_CATEGORY_C2.Content}
                </button>
              </Tooltip>
            </div>
          </section>
        )}

        <section className="list-type">
          <h4>{APP_TEXTS.SEISMIC_LOADS_DESIGN_OPTIONS.Content}</h4>
          {this.IsICC4RedHeadOrRamset ?
            (
              <div>
                <section className="list-type">
                  <h4>{APP_TEXTS.PROTECT_AGAINST_TENSION_FAILURE.Content}</h4>

                  <UncontrolledDropdown className="design-dropdown">
                    <DropdownToggle caret className="design-dropdown-toggle">
                      {APP_TEXTS.SELECT_DESIGN_OPTION.Content}
                    </DropdownToggle>
                    <DropdownMenu className="design-dropdown-menu">
                      {this.generateDesignItem(designOptions.DUCTILITY_REQ,
                        seismicParams.DESIGN_AGAINST_NONDUCTILE,
                        (<span>{APP_TEXTS.ANCHOR_DUCTILITY_REQUIREMENTS.Content}<br />
                          {Number(this.props.designStd) === standardList['CSA'] ? 
                            (<span>{APP_TEXTS.SEISMIC_OPTION_D4_3_5_3_a.Content}</span>) :
                            (<span>{APP_TEXTS.SEISMIC_LOAD_OPTION.Content}</span>)}</span>),
                        "icon_seismic-design-17-2-3-4-3-a", 
                        (Number(this.props.designStd) === standardList['CSA'] ? 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_D4_3_5_3_a.Content : 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_17_2_3_4_3_a.Content))}

                      {this.generateDesignItem(designOptions.CAPACITY,
                        seismicParams.DESIGN_AGAINST_NONDUCTILE,
                        (<span>{Number(this.props.designStd) === standardList['CSA'] ? 
                          (<span>{APP_TEXTS.CAPACITY_DESIGN.Content}<br />{APP_TEXTS.SEISMIC_OPTION_D4_3_5_3_b.Content}</span>) :
                          (<span>{APP_TEXTS.CAPACITY_DESIGN_OPTION.Content}</span>)}</span>),
                        "icon_seismic-design-17-2-3-4-3-b", 
                        (Number(this.props.designStd) === standardList['CSA'] ? 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_D4_3_5_3_b.Content : 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_17_2_3_4_3_b.Content))}

                      {this.generateDesignItem(designOptions.ELASTIC,
                        seismicParams.DESIGN_AGAINST_NONDUCTILE,
                        (<span>{APP_TEXTS.ELASTIC_DESIGN.Content} <br />
                          {Number(this.props.designStd) === standardList['CSA'] ? 
                            (<span>{APP_TEXTS.SEISMIC_OPTION_D4_3_5_3_c.Content}</span>) :
                            (<span>{APP_TEXTS.ELASTIC_DESIGN_OPTION.Content}</span>)}</span>),
                        "icon_seismic-design-17-2-3-4-3-c", 
                        (Number(this.props.designStd) === standardList['CSA'] ? 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_D4_3_5_3_c.Content : 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_17_2_3_4_3_c.Content))}

                      {this.generateDesignItem(designOptions.ELASTIC_2,
                        seismicParams.DESIGN_AGAINST_NONDUCTILE,
                        (<span>{APP_TEXTS.ELASTIC_DESIGN.Content} <br />
                          {Number(this.props.designStd) === standardList['CSA'] ? 
                            (<span>{APP_TEXTS.SEISMIC_OPTION_D4_3_5_3_d.Content}</span>) :
                            (<span>{APP_TEXTS.ELASTIC_DESIGN_OPTION_D.Content}</span>)}</span>),
                        "icon_seismic-design-17-2-3-4-3-d", 
                        (Number(this.props.designStd) === standardList['CSA'] ? 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_D4_3_5_3_d.Content : 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_17_2_3_4_3_d.Content))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </section>

                <section className="list-type">
                  <h4>{APP_TEXTS.PROTECT_AGAINST_SHEAR_FAILURE.Content}</h4>

                  <UncontrolledDropdown className="design-dropdown">
                    <DropdownToggle caret className="design-dropdown-toggle">
                      {APP_TEXTS.SELECT_DESIGN_OPTION.Content}
                    </DropdownToggle>
                    <DropdownMenu className="design-dropdown-menu">
                      {this.generateDesignItem(designOptions.CAPACITY,
                        seismicParams.DESIGN_AGAINST_PREMATURE,
                        (<span>{Number(this.props.designStd) === standardList['CSA'] ? 
                          (<span>{APP_TEXTS.CAPACITY_DESIGN.Content}<br />{APP_TEXTS.SEISMIC_OPTION_D4_3_6_3_a.Content}</span>) :
                          (<span>{APP_TEXTS.CAPACITY_DESIGN_OPTION_A.Content}</span>)}</span>),
                        "icon_seismic-design-17-2-3-5-3-a", 
                        (Number(this.props.designStd) === standardList['CSA'] ? 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_D4_3_6_3_a.Content : 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_17_2_3_5_3_a.Content))}

                      {this.generateDesignItem(designOptions.ELASTIC,
                        seismicParams.DESIGN_AGAINST_PREMATURE,
                        (<span>{APP_TEXTS.ELASTIC_DESIGN.Content} <br />
                          {Number(this.props.designStd) === standardList['CSA'] ? 
                            (<span>{APP_TEXTS.SEISMIC_OPTION_D4_3_6_3_b.Content}</span>) :
                            (<span>{APP_TEXTS.ELASTIC_DESIGN_OPTION_B.Content}</span>)}</span>),
                        "icon_seismic-design-17-2-3-5-3-b", 
                        (Number(this.props.designStd) === standardList['CSA'] ? 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_D4_3_6_3_b.Content : 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_17_2_3_5_3_b.Content))}

                      {this.generateDesignItem(designOptions.ELASTIC_2,
                        seismicParams.DESIGN_AGAINST_PREMATURE,
                        (<span>{APP_TEXTS.ELASTIC_DESIGN.Content} <br />
                          {Number(this.props.designStd) === standardList['CSA'] ? 
                            (<span>{APP_TEXTS.SEISMIC_OPTION_D4_3_6_3_c.Content}</span>) :
                            (<span>{APP_TEXTS.ELASTIC_DESIGN_OPTION_C.Content}</span>)}</span>),
                        "icon_seismic-design-17-2-3-5-3-c", 
                        (Number(this.props.designStd) === standardList['CSA'] ? 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_D4_3_6_3_c.Content : 
                          APP_TOOLTIPS.TOOLTIP_SEISMIC_OPTION_17_2_3_5_3_c.Content))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </section>
              </div>
            ) :
            (
              <div className="btn-group">
                <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_DESIGN_CAPACITY.Content}>
                  <button
                    onClick={() => {
                      this.updateValue(designOptions.CAPACITY, seismicParams.DESIGN_OPTION);
                      this.setState({
                        designOption: designOptions.CAPACITY
                      });
                    }}
                    className={`btn ${extraField[seismicParams.DESIGN_OPTION] === designOptions.CAPACITY && 'ToggleButton--active'}`}
                  >
                    {APP_TEXTS.CAPACITY_DESIGN.Content}
                  </button>
                </Tooltip>
                <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_DESIGN_ELASTIC.Content}>
                  <button
                    onClick={() => {
                      this.updateValue(designOptions.ELASTIC, seismicParams.DESIGN_OPTION);
                      this.setState({
                        designOption: designOptions.ELASTIC
                      });
                    }}
                    className={`btn ${extraField[seismicParams.DESIGN_OPTION] === designOptions.ELASTIC && 'ToggleButton--active'}`}
                  >
                    {APP_TEXTS.ELASTIC_DESIGN.Content}
                  </button>
                </Tooltip>
              </div>
            )}
        </section>

        {!(this.IsICC4RedHeadOrRamset) && (
          <section className="list-type">
            <h4>{APP_TEXTS.SEISMIC_LOADS_INSTALLATION.Content}</h4>

            <Tooltip content={APP_TOOLTIPS.TOOLTIP_SEISMIC_FILLED_HOLES.Content}>
              <div className="form-check">
                <label className="form-check-label" htmlFor="filledHoles">
                  <input
                    className="form-check-input"
                    id="filledHoles"
                    name={seismicParams.FILLED_HOLES}
                    type="checkbox"
                    defaultChecked={extraField[seismicParams.FILLED_HOLES]}
                    onInput={e => this.updateValue(e.target.checked, seismicParams.FILLED_HOLES)}
                  />
                  {APP_TEXTS.FILLED_HOLES_DESCRIPTION.Content} &alpha; {APP_TEXTS.FILLED_HOLES_DESCRIPTION2.Content}
                </label>
              </div>
            </Tooltip>
          </section>
        )}

        {!(this.IsICC4RedHeadOrRamset) && (
        <LimitingDisplacement
          combination={this.props.combination}
          onUpdate={this.updateValue}
        />
        )}
      </div>
    );
  }

  updateValue = (value, key) => {
    this.props.onUpdate({
      [key]: value
    });
  }

  changeDesignValue = (e, value, key) => {
    let dropdownToggle = e.currentTarget.parentNode.previousSibling;
    dropdownToggle.innerHTML = e.currentTarget.innerHTML;
    // DropdownItem -> design-option div -> content icon div -> span 
    dropdownToggle.children[0].children[1].children[0].className += "-active";
    this.updateValue(value, key);
    this.setState({ [key]: value });
  }

  generateDesignItem = (value, key, content, icon, tooltip) => {
    return (
      <DropdownItem
        className="design-dropdown-item"
        onClick={(e) => {
          this.changeDesignValue(e, value, key);
        }
        }>
        <Tooltip content={tooltip}>
          <div className="design-option">
            <div className="content description">
              {content}
            </div>
            <div className="content icon">
              <span className={ this.state[key] === value ? (icon + "-active") : icon} />
            </div>
          </div>
        </Tooltip>
      </DropdownItem>
    );
  }

  get IsICC4RedHeadOrRamset() {
    return (
      (Number(this.props.designStd) === standardList['ICC.Post'] || 
      Number(this.props.designStd) === standardList['ICC.Cast'] ||
      Number(this.props.designStd) === standardList['CSA']) 
      &&
      (BRAND === brandList.Ramset || BRAND === brandList.Redhead)
    );
  }

  queryZipCode(code) {
    this.setState({ waitingResponse: true });
    loadsTabService.getFrenchAreas(code).then((res) => {
      if (res && res.length && this.state.zipCode === res[0].PostalCode) { // check if the zipCode was changed in the meantime
        let selectedTown = this.props.combination.extraField["frenchArea"];
        selectedTown = selectedTown && res.find(town => town.Town === selectedTown.Town);
        if (!selectedTown)
          selectedTown = res[0];
        this.setState({ isValidZipCode: true, towns: res, selectedTown, waitingResponse: false });
      } else {
        this.setState({ waitingResponse: false, isValidZipCode: false, selectedTown: null, towns: [] });
      }
    }, () => this.setState({ waitingResponse: false, isValidZipCode: false }));
  }

  getBuildingClassTooltip(internalName) {
    switch (Number(internalName)) {
      case 0: { return APP_TOOLTIPS.TOOLTIP_SEISMIC_BUILDINGS_CLASS_1.Content; }
      case 1: { return APP_TOOLTIPS.TOOLTIP_SEISMIC_BUILDINGS_CLASS_2.Content; }
      case 2: { return APP_TOOLTIPS.TOOLTIP_SEISMIC_BUILDINGS_CLASS_3.Content; }
      case 3: { return APP_TOOLTIPS.TOOLTIP_SEISMIC_BUILDINGS_CLASS_4.Content; }
      default: { return ""; }
    }
  }

}

export default SeismicLoads;



// WEBPACK FOOTER //
// ./src/views/Loads/GeneralLoading/DesignLoading/SeismicLoads/SeismicLoads.js